import { Cloneable } from "./cloneable";

import { Serializable } from "./serializable";
import { fromJS, List, Record } from "immutable";


export interface InventoryCountJSON {
  ID: number;
  name: string;
  dateTime: string;
  notes: string;
  statusID: number;
  statusName: string;
  isFullCount: number;
  lineItems: List<InventoryCountLineItem>;
  deleted: number;
}

export interface InventoryCountLineItem {
  ID: number; 
  productID: number; 
  expectedCount: number;
  actualCount: number;
}

export interface InventoryCountSerialized {
  ID: number;
  name: string;
  dateTime: string;
  notes: string;
  statusID: number;
  statusName: string;
  isFullCount: number;
  deleted: number;
  lineItems: List<InventoryCountLineItem>;
}

export class InventoryCount
  implements Cloneable<InventoryCount, InventoryCountJSON>, Serializable<InventoryCountSerialized> {

  public readonly ID: number;

  public readonly dateTime: string;

  public readonly name: string;

  public readonly notes: string;

  public readonly statusID: number;

  public readonly statusName: string;

  public readonly isFullCount: number;

  public readonly deleted: number;

  public readonly lineItems: List<InventoryCountLineItem>;


  constructor(options: InventoryCountJSON) {
    this.ID = options.ID;
    this.dateTime = options.dateTime;
    this.name = options.name;
    this.notes = options.notes;
    this.statusID = options.statusID;
    this.statusName = options.statusName;
    this.isFullCount = options.isFullCount;
    this.deleted = options.deleted;
    this.lineItems = options.lineItems;
  }

  public getID(): number {
    return this.ID;
  }

  public getDateTime(): string {
    return this.dateTime;
  }

  public getName(): string {
    return this.name;
  }

  public getStatusID(): number {
    return this.statusID;
  }

  public getStatusName(): string {
    return this.statusName;
  }

  public getFullCountID(): number {
    return this.isFullCount;
  }

  public getDeletedStatus(): number {
    return this.deleted;
  }

  public getLineItems(){
    return this.lineItems;
  }

  public getNotes(): string {
    return this.notes;
  }

  public setID(value: number): InventoryCount {
    const data: InventoryCountJSON = this.toJSON();
    data.ID = value;
    return new InventoryCount(data);
  }

  public setDateTime(value: string): InventoryCount {
    const data: InventoryCountJSON = this.toJSON();
    data.dateTime = value;
    return new InventoryCount(data);
  }
  public setName(value: string): InventoryCount {
    const data: InventoryCountJSON = this.toJSON();
    data.name = value;
    return new InventoryCount(data);
  }

  public setStatusID(value: number): InventoryCount {
    const data: InventoryCountJSON = this.toJSON();
    data.statusID = value;
    return new InventoryCount(data);
  }

  public setStatusName(value: string): InventoryCount {
    const data: InventoryCountJSON = this.toJSON();
    data.statusName = value;
    return new InventoryCount(data);
  }

  public setFullCount(value: number): InventoryCount {
    const data: InventoryCountJSON = this.toJSON();
    data.isFullCount = value;
    return new InventoryCount(data);
  }

  public setDeletedStatus(value: number): InventoryCount {
    const data: InventoryCountJSON = this.toJSON();
    data.deleted = value;
    return new InventoryCount(data);
  }

  public setLineItems(value: List<InventoryCountLineItem>): InventoryCount{
    const data: InventoryCountJSON = this.toJSON();
    data.lineItems = value;
    return new InventoryCount(data);
  }

  public setNotes(value: string): InventoryCount{
    const data: InventoryCountJSON = this.toJSON();
    data.notes = value;
    return new InventoryCount(data);
  }

  public static parseInventoryCountData(params: Object): InventoryCount {

    // var statusNameMaping = { 1: "Completed", 2: "Paused" }

    return new InventoryCount({
      ID: params["ID"],
      name: params["name"],
      dateTime: params["dateTime"],
      notes: params["notes"],
      statusID: params["statusID"],
      isFullCount: params["isFullCount"],
      // statusName: statusNameMaping[params["statusID"]],
      statusName: params["statusID"],
      deleted: params["deleted"],
      lineItems: params["lineItems"]
    });
  }

  public toJSON(): InventoryCountJSON {
    return {
      ID: this.ID,
      dateTime: this.dateTime,
      name: this.name,
      notes: this.notes,
      statusID: this.statusID,
      statusName: this.statusName,
      isFullCount: this.isFullCount,
      deleted: this.deleted,
      lineItems: this.lineItems
    };
  }

  public clone(): InventoryCount {
    return new InventoryCount(this.toJSON());
  }

  public serialize(): InventoryCountSerialized {
    return {
      ID: this.ID,
      dateTime: this.dateTime,
      name: this.name,
      notes: this.notes,
      statusID: this.statusID,
      statusName: this.statusName,
      isFullCount: this.isFullCount,
      deleted: this.deleted,
      lineItems: this.lineItems
    };
  }
}
